import { IState } from '../../../store';
import { selectAgentLists } from '../selectAgentLists';

export const isShowElectronicTradeDisclaimer = (state: IState) => {
  const agentLists = selectAgentLists(state);

  return agentLists.includes('electronTradeSite');
};
